import { postEmailValidation } from "features/verificar-email/services/verifyEmailApi";

export function validateAdesaoEmail(
  userId: string | null,
  token: string | null
): Promise<void> {
  return postEmailValidation(userId, token);
}
